import React, { Component } from 'react'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import icon from '@fortawesome/fontawesome-free-regular/faCircle'
import checkedIcon from '@fortawesome/fontawesome-free-solid/faCheckCircle'

import * as Constants from '../../helpers/Constants'

class Radio extends Component {
  state = {
    hover: false
  }

  render() {
    const {
      underContainerStyle,
      rightContainerStyle,
      titleUnderStyle,
      titleRightStyle
    } = styles
    const { hover } = this.state
    const {
      onClick,
      selected,
      color = Constants.WHITE_LABEL.colors.primary,
      hoverColor = Constants.WHITE_LABEL.colors.primaryHover,
      style,
      title = '',
      titlePosition = 'under'
    } = this.props

    const containerStyle =
      titlePosition === 'under' ? underContainerStyle : rightContainerStyle
    const titleStyle =
      titlePosition === 'under' ? titleUnderStyle : titleRightStyle

    return (
      <a
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
        onClick={() => onClick()}
        style={{ ...containerStyle, ...style }}
      >
        <FontAwesomeIcon
          icon={selected ? checkedIcon : icon}
          style={{ fontSize: 26, color: hover ? hoverColor : color }}
        />
        {title ? <p style={titleStyle}>{title}</p> : null}
      </a>
    )
  }
}

const styles = {
  underContainerStyle: {
    backgroundColor: 'transparent',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  rightContainerStyle: {
    backgroundColor: 'transparent',
    display: 'flex',
    alignItems: 'center'
  },
  titleUnderStyle: {
    margin: 0,
    marginTop: 5,
    textAlign: 'center',
    fontSize: 14
  },
  titleRightStyle: {
    margin: 0,
    marginLeft: 5,
    textAlign: 'center',
    fontSize: 14
  }
}

export { Radio }



// WEBPACK FOOTER //
// ./src/components/kevinsLegacy/Radio.js